import store from "./store";

export default {
  name: "app",
  store: store,
};
